import {Component, Input, OnInit} from '@angular/core';
import {EventsService} from '../../../events.service';
import {GlobalService} from '../../../../global.service';

@Component({
  selector: 'app-player-card-resuable',
  templateUrl: './player-card-resuable.component.html',
  styleUrls: ['./player-card-resuable.component.scss']
})
export class PlayerCardResuableComponent implements OnInit {
  loadIndicator = false
  @Input() participant;
  @Input() backgroundImageBody;
  @Input() FontColor;
  styleExpression;
  styleExpressionFont;
  constructor(private eventService: EventsService, public globalService: GlobalService) {
  }

  ngOnInit() {
    this.styleExpression = {backgroundImage:this.backgroundImageBody }
    this.styleExpressionFont = {color: this.FontColor}
    }
  }


